import {
  Container,
  Page,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { FunctionComponent } from 'react';

import { OrganizationInformation } from './OrganizationInformation';
import { OrganizationTenantInfo } from './OrganizationTenantInfo';

export const OrganizationDetails: FunctionComponent =
  (): JSX.Element | null => {
    return (
      <Page>
        <Container size="medium">
          <OrganizationInformation className="mb-os1-spacing" />
          <OrganizationTenantInfo hideBackButton={true} />
        </Container>
      </Page>
    );
  };
